module.exports = __webpack_public_path__ + "static/img/checkpoint4TC.3b8cc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/checkpoint4TC.png
// module id = 6kF5
// module chunks = 0